<template>
  <div class="clause-wrapper">
    <div class="clause-body">
      <header class="header">免赔约定</header>
      <div class="content">
        <p>
          <span style="font-size: 12px">各货品对应的免赔约定如下：</span>
        </p>
        <p class="MsoListParagraph" style="margin-left: 24px">
          <strong
            ><span style="font-size: 12px">1、<span style="font: 9px">&nbsp; </span></span></strong
          ><strong><span style="font-size: 12px">普通货物和易碎易损品的免赔约定如下：</span></strong>
        </p>
        <p class="MsoListParagraph" style="margin-left: 24px; text-indent: 0">
          <span style="font-size: 12px; color: black">每次事故绝对免赔5000元或损失金额的15%，以高者为准。</span>
        </p>
        <p class="MsoListParagraph" style="margin-left: 24px">
          <strong
            ><span style="font-size: 12px; color: black">2、<span style="font: 9px">&nbsp; </span></span></strong
          ><strong><span style="font-size: 12px; color: black">散货（无规则包装货物）</span></strong
          ><strong><span style="font-size: 12px">的免赔约定如下：</span></strong>
        </p>
        <p class="MsoListParagraph" style="margin-left: 24px; text-indent: 0">
          <span style="font-size: 12px; color: black">每次事故绝对免赔5000元或损失金额的15%，以高者为准。</span>
        </p>
        <p class="MsoListParagraph" style="margin-left: 24px">
          <strong
            ><span style="font-size: 12px">3、<span style="font: 9px">&nbsp; </span></span></strong
          ><strong><span style="font-size: 12px">生鲜及冷藏品的免赔约定如下</span></strong>
        </p>
        <p class="MsoListParagraph" style="margin-left: 24px; text-indent: 0">
          <span style="font-size: 12px; color: black">每次事故绝对免赔3000元或损失金额的20%，以高者为准。</span>
        </p>
      </div>
      <div class="close-btn" @click="closeClause">关闭</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Deductible",
  methods: {
    closeClause() {
      this.$router.back(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.clause-wrapper {
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  .clause-body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    color: #333;
    background-color: #fff;
    z-index: 9999;
    -webkit-transition: 300ms all;
    transition: 300ms all;
    .header {
      height: 13.33vw;
      line-height: 13.33vw;
      font-size: 4.8vw;
      font-weight: bold;
      border-bottom: 0.27vw solid #f5f5f9;
      text-align: center;
    }
    .content {
      height: 60vh;
      padding: 2.67vw 5vw;
      overflow: auto;
      text-align: justify;
    }
    .close-btn {
      height: 12vw;
      line-height: 12vw;
      text-align: center;
      color: #ffffff;
      background: #3385ff;
    }
  }
}
</style>
